module.exports = __webpack_public_path__ + "static/media/p3_img3.80cf5d72.png";